import {
    fetchPaddleCountriesList,
    getBillingContinue,
    getBillingInfo,
    getBillingStatus,
    getPlanUpgradePreview,
    restartPaymentFlow,
    startBillingProcess,
    upgradePlan,
} from './billing.utils';

export function getInitialState () {
    return {
        billingStatus: '',
        isLoading: false,
    };
}

const billing = {
    namespaced: true,
    state: getInitialState(),
    mutations: {
        setBillingSummary (state, { billingStatus }) {
            state.billingStatus = billingStatus;
        },
        setLoading (state, { value }) {
            state.isLoading = value;
        },
    },
    getters: {
        isLoading: (state) => state.isLoading,
    },
    actions: {
        async startBillingProcess ({ commit }, requestBody) {
            try {
                commit('setLoading', { value: true });
                const stripeSubscription = await startBillingProcess(requestBody);
                commit('setLoading', { value: false });

                return stripeSubscription;
            } catch (error) {
                commit('setLoading', { value: false });
                throw error;
            }
        },
        async getBillingStatus ({ commit }) {
            try {
                commit('setLoading', { value: true });
                const status = await getBillingStatus();
                commit('setBillingSummary', { billingStatus: status });
                commit('setLoading', { value: false });

                return status;
            } catch (error) {
                commit('setLoading', { value: false });
                throw error;
            }
        },
        async getBillingContinue ({ commit }) {
            try {
                commit('setLoading', { value: true });
                const status = await getBillingContinue();
                commit('setLoading', { value: false });

                return status;
            } catch (error) {
                commit('setLoading', { value: false });
                throw error;
            }
        },
        async getBillingInfo ({ commit }) {
            try {
                commit('setLoading', { value: true });
                const billingInfo = await getBillingInfo();
                commit('setLoading', { value: false });

                return billingInfo;
            } catch (error) {
                commit('setLoading', { value: false });
                throw error;
            }
        },
        async getPlanUpgradePreview ({ commit }, { planName, mau, returnUrl }) {
            try {
                commit('setLoading', { value: true });
                const planUpdatePreview = await getPlanUpgradePreview(planName, mau, returnUrl);
                commit('setLoading', { value: false });

                return planUpdatePreview;
            } catch (error) {
                commit('setLoading', { value: false });
                throw error;
            }
        },
        async restartPaymentFlow ({ commit }) {
            try {
                commit('setLoading', { value: true });
                const status = await restartPaymentFlow();
                commit('setLoading', { value: false });

                return status;
            } catch (error) {
                commit('setLoading', { value: false });
                throw error;
            }
        },
        async fetchPaddleCountriesList () {
            try {
                const countriesList = await fetchPaddleCountriesList();

                return countriesList;
            } catch (error) {
                throw error;
            }
        },
        async upgradePlan ({ commit }, { termsVersion }) {
            try {
                commit('setLoading', { value: true });
                const upgradedPlan = await upgradePlan({ termsVersion });
                commit('setLoading', { value: false });

                return upgradedPlan;
            } catch (error) {
                commit('setLoading', { value: false });
                throw error;
            }
        },
    },
};

export default billing;
